import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownTimerProps = {
  label: string;
  note: string;
  tone?: 'light' | 'dark';
};
const START_SECONDS = 18 * 3600 + 53 * 60 + 5;
export function CountdownTimer({
  label,
  note,
  tone = 'light'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const isDark = tone === 'dark';
  const units = [{
    value: hours,
    name: 'hrs'
  }, {
    value: minutes,
    name: 'min'
  }, {
    value: seconds,
    name: 'seg'
  }];
  return <div className="text-center" data-id="element-50" data-mp="1fdwuu8ajmamg">
      <p className={`text-sm font-semibold uppercase tracking-[0.18em] ${isDark ? 'text-mint-200' : 'text-terra-dark'}`} data-id="element-51" data-mp="1achcwp3nwk8a">
        {label}
      </p>
      <div className="mt-5 flex items-center justify-center gap-3" data-id="element-52" data-mp="15f7cyfincq67">
        {units.map(unit => <div key={unit.name} className={`w-24 rounded-2xl px-3 py-4 sm:w-28 ${isDark ? 'bg-white/10' : 'bg-sand shadow-soft'}`} data-id="element-53" data-mp="34pgxyxqta6my">
            <span className={`block font-display text-4xl tabular-nums sm:text-5xl ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-54" data-mp="2zpkuczm10h7x">
              {unit.value}
            </span>
            <span className={`mt-1 block text-xs uppercase tracking-[0.16em] ${isDark ? 'text-mint-200' : 'text-ink-muted'}`} data-id="element-55" data-mp="1h1cpds84xcx3">
              {unit.name}
            </span>
          </div>)}
      </div>
      <p className={`mt-5 text-sm ${isDark ? 'text-mint-100' : 'text-ink-muted'}`} data-id="element-56" data-mp="172dhibv71lb5">
        {note}
      </p>
    </div>;
}